// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewsItems_wrapper__3FhQo","button":"ReviewsItems_button__3y1Id","button--filled":"ReviewsItems_button--filled__2Kgrb"};